export const APP_NAME = 'iFMS';
